import { TokenIcon } from './holdings-table'

/** a square chip in a dialog header: the chain, the QR code (John, Nov 2 2026: "make those ... buttons bigger", "not the text so much") */
export const HEADER_CHIP = 'chip flex size-10 items-center justify-center !rounded-lg !p-0'

/** the chain, lit, beside a dialog's title (John, Nov 2 2026: "make this whole chain logo a little bit bigger too ... wherever") */
export function ChainChip({ imageUrl }: { imageUrl?: string }) {
  return (
    <button type="button" className={HEADER_CHIP} aria-pressed="true" title="Solana" aria-label="Solana">
      <TokenIcon symbol="SOL" imageUrl={imageUrl} size="size-6" />
    </button>
  )
}

/** the thin rule between the chain (or the QR code) and the platform group in a dialog header (John, Nov 2 2026: "a | or separator") */
export function HeaderRule() {
  return <span className="h-7 w-px bg-muted/40" aria-hidden="true" />
}
